import React, { memo } from 'react';
import { KDims } from 'uikit';

import { dataMobile, dataDesktop } from './data';

import TemplateLayout from '../../TemplateLayout';

const Taboo = () => {
  const isMobile = KDims.isMobile();

  return (
    <>
      <TemplateLayout data={isMobile ? dataMobile : dataDesktop} />
    </>
  );
};

export default memo(Taboo);
